import { render } from "./SecurityTab.vue?vue&type=template&id=022a298b&scoped=true"
import script from "./SecurityTab.vue?vue&type=script&lang=js"
export * from "./SecurityTab.vue?vue&type=script&lang=js"

import "./SecurityTab.vue?vue&type=style&index=0&id=022a298b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022a298b"]])

export default __exports__